export default "__VITE_ASSET__BxyG2ZYF__"